export default __webpack_public_path__ + "static/media/learose5-2048w.c6905790.png";